export default {
    apiUrl: "https://unihub-dev.uniqa.cz/hyperionapi/api",
    authUrl: "https://login-dev.uniqa.cz/auth/realms/people/protocol/openid-connect",
    authRedirectUri: "https://unihub-dev.uniqa.cz",
    damageReportUrl: "https://skody-t.uniqa.cz/form/redirect/",
    damageReportUrlBaseSK: "https://skody-t.uniqa.sk/",
    wsUrl: "",
    envName: "-Dev" 
}